/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class MonitorReviewsAssignedConversationIssueNewRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.reviews.assigned.conversation.issue-new',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(MonitorReviewsAssignedConversationIssueNewRoute);
